import { useContext } from 'react';
import * as R from 'ramda';

import CreateAssetModalContext, {
  ModalStep,
} from '@atom/components/common/createAssetModal/CreateAssetModalContext';
import { Stepper } from '@atom/mui';
import { numberToLocaleString } from '@atom/utilities/currencyUtility';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import { getRouteSubtext } from './assetRouteTab/assetRouteUtilities';

import classes from './createAssetModal.module.css';

const { StepLabel, Step } = Stepper;

const StepperSidebar = () => {
  const {
    activeStep,
    STEPS_ARRAY,
    schema,
    category,
    rate,
    unit,
    name,
    errorAttributeIds,
    address,
    routeData,
    routeOptions,
    milePost,
  } = useContext(CreateAssetModalContext);

  const activeStepIndex = R.findIndex(R.propEq(activeStep, 'value'))(
    STEPS_ARRAY,
  );

  const getStepSubtext = (step: ModalStep) => {
    switch (step) {
      case ModalStep.TYPE: {
        return schema?.name || '';
      }
      case ModalStep.FOLDER: {
        return category?.name || '';
      }
      case ModalStep.LOCATION: {
        return address || '';
      }
      case ModalStep.ROUTE: {
        return getRouteSubtext(routeData, routeOptions, milePost);
      }
      case ModalStep.COST: {
        return (!isNilOrEmpty(rate) && unit) ||
          activeStep === ModalStep.COST ? (
          <span className={classes.costSubtext}>{`${numberToLocaleString(
            rate,
          )} / ${unit}`}</span>
        ) : (
          ''
        );
      }
      case ModalStep.NAME: {
        return name || '';
      }
      default: {
        return '';
      }
    }
  };

  return (
    <div className={classes.stepperContainer}>
      <Stepper activeStep={activeStepIndex} orientation="vertical">
        {STEPS_ARRAY.map(step => {
          const subtext = getStepSubtext(step.value);
          const error =
            step.value === ModalStep.ATTRIBUTES && errorAttributeIds.size > 0;

          return (
            <Step key={step.title}>
              <StepLabel error={error}>
                <>
                  <div>{step.title}</div>
                  {subtext && (
                    <div className={classes.stepSubtext}>{subtext}</div>
                  )}
                </>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
};

export default StepperSidebar;
